<template>
    <div id="fab">
        <div>
            <ul class="parent">
                <li :key="i" v-for="(f, i) in fabs" :value="f" class="child">
                    <span class="justify-content-center">
                        <span class="mr-1">
                            <a-checkbox @change="fabInfoChanged()" v-model="f.enable" class="mx-2 p-1" />
                        </span>
                        <span class="ml-3">
                            {{ $t(`message.${f.type}FabListDescription`) }}
                        </span>
                        <div v-if="f.type === 'whatsapp'" class="mt-2 pt-2">
                            <div v-show="f.enable === true" class="text-center">
                                <div
                                    class="row d-flex flex-row justify-content-center align-items-center text-center"
                                    style="gap: 5px"
                                    @blur="fabInfoChanged(f.path, f.type)"
                                >
                                    <vue-country-code
                                        class="col-3 country-code my-2 ml-2 mr-0"
                                        style="height: 32px"
                                        @onSelect="onSelect($event, f.type)"
                                        :enabledCountryCode="true"
                                        :defaultCountry="f.country"
                                        :preferredCountries="[`${f.country}`]"
                                    />
                                    <a-input
                                        class="col-5 inputs my-2 mr-2 p-3"
                                        v-model="f.path"
                                        v-if="f.path !== undefined"
                                        :placeholder="$t('message.phone')"
                                        autocomplete="off"
                                        trim
                                        type="text"
                                        v-mask="'(###)#######'"
                                        @blur="fabInfoChanged(f.path, f.type)"
                                        :style="{ border: activeBorderWP }"
                                        style="margin-left: 1px"
                                    />
                                    <a-icon
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="$t('message.sendNumber', { path: '+' + f.callingCode + f.path })"
                                        class="col-1 mx-3"
                                        style="
                                            font-size: 20px;
                                            color: var(--color-bg-primary-default);
                                            background-color: #ffffff;
                                            border-radius: 50%;
                                        "
                                        theme="filled"
                                        type="info-circle"
                                    />
                                </div>
                                <div
                                    class="row d-flex flex-row text-center justify-content-center align-items-center"
                                    style="gap: 10px"
                                >
                                    <a-textarea
                                        style="position: relative; width: 100%; height: 15vh"
                                        class="col-8 inputs m-2 ml-0 p-3"
                                        type="text"
                                        v-model="f.text"
                                        v-if="f.text !== undefined"
                                        :placeholder="$t('message.typeYourMessage')"
                                        maxlength="300"
                                        @blur="fabInfoChanged(f.path, f.type)"
                                    />
                                    <a-icon
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="$t('message.typeYourMessageDesc')"
                                        class="col-1 mx-3"
                                        style="
                                            font-size: 20px;
                                            color: var(--color-bg-primary-default);
                                            background-color: #ffffff;
                                            border-radius: 50%;
                                        "
                                        theme="filled"
                                        type="info-circle"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-if="f.type === 'phone'" class="mt-2 pt-2">
                            <div v-show="f.enable === true" class="text-center">
                                <div
                                    class="row d-flex flex-row justify-content-center align-items-center text-center"
                                    style="gap: 10px"
                                    @blur="fabInfoChanged(f.tel, f.type)"
                                >
                                    <vue-country-code
                                        class="col-3 country-code my-2 ml-2 mr-0"
                                        style="height: 32px"
                                        @onSelect="onSelect($event, f.type)"
                                        :enabledCountryCode="true"
                                        :defaultCountry="f.country"
                                        :preferredCountries="[`${f.country}`]"
                                    />
                                    <input
                                        class="col-5 inputs my-2 mr-0 p-3"
                                        v-model="f.tel"
                                        :placeholder="$t('message.phone')"
                                        autocomplete="off"
                                        trim
                                        type="text"
                                        v-mask="'(###)#######'"
                                        @blur="fabInfoChanged(f.tel, f.type)"
                                        :style="{ border: activeBorderPhone }"
                                        style="margin-left: 1px; height: 32px"
                                    />
                                    <a-icon
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="
                                            $t('message.callNumber', { phoneNumber: '+' + f.callingCode + f.tel })
                                        "
                                        class="col-1 mx-3"
                                        style="
                                            font-size: 20px;
                                            color: var(--color-bg-primary-default);
                                            background-color: #ffffff;
                                            border-radius: 50%;
                                        "
                                        theme="filled"
                                        type="info-circle"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-if="f.type === 'email'" class="mt-2 pt-2">
                            <div v-show="f.enable === true" class="text-center">
                                <div
                                    class="row d-flex flex-row justify-content-center align-items-center text-center"
                                    style="gap: 120px"
                                    @blur="fabInfoChanged(f.mail, f.type)"
                                >
                                    <a-input
                                        class="col-5 inputs my-2 mr-2 p-3"
                                        v-model="f.mail"
                                        v-if="f.mail !== undefined"
                                        :placeholder="$t('message.email')"
                                        autocomplete="off"
                                        trim
                                        type="text"
                                        @blur="fabInfoChanged(f.mail, f.type)"
                                        :class="validInput"
                                        style="margin-left: 1px"
                                    />
                                    <a-icon
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="$t('message.email')"
                                        class="col-1 mx-3"
                                        style="
                                            font-size: 20px;
                                            color: var(--color-bg-primary-default);
                                            background-color: #ffffff;
                                            border-radius: 50%;
                                        "
                                        theme="filled"
                                        type="info-circle"
                                    />
                                </div>
                                <div class="row d-flex flex-row text-center justify-content-center align-items-center">
                                    <textarea
                                        style="position: relative; width: 100%; height: 15vh"
                                        v-model="f.text"
                                        class="col-8 inputs m-2 ml-0 p-3"
                                        type="text"
                                        v-if="f.text !== undefined"
                                        :placeholder="$t('message.typeYourMessage')"
                                        maxlength="300"
                                        @blur="fabInfoChanged(f.mail, f.type)"
                                    />
                                    <a-icon
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="$t('message.typeYourMessageMail')"
                                        class="col-1 mx-3"
                                        style="
                                            font-size: 20px;
                                            color: var(--color-bg-primary-default);
                                            background-color: #ffffff;
                                            border-radius: 50%;
                                        "
                                        theme="filled"
                                        type="info-circle"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-if="f.type === 'facebook'" class="mt-2 pt-2">
                            <div v-show="f.enable === true" class="text-center">
                                <div
                                    class="row d-flex flex-row justify-content-center align-items-center text-center"
                                    @blur="fabInfoChanged(f.path, f.type)"
                                >
                                    <a-input
                                        class="col-8 inputs my-2 mr-2 p-3"
                                        v-model="f.path"
                                        v-if="f.path !== undefined"
                                        placeholder="https://www.facebook.com/..."
                                        autocomplete="off"
                                        trim
                                        type="text"
                                        @blur="fabInfoChanged(f.path, f.type)"
                                        style="margin-left: 1px"
                                    />
                                    <a-icon
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="$t('message.typeYourChannelLink', { channelLink: f.type })"
                                        class="col-1 mx-3"
                                        style="
                                            font-size: 20px;
                                            color: var(--color-bg-primary-default);
                                            background-color: #ffffff;
                                            border-radius: 50%;
                                        "
                                        theme="filled"
                                        type="info-circle"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-if="f.type === 'twitter'" class="mt-2 pt-2">
                            <div v-show="f.enable === true" class="text-center">
                                <div
                                    class="row d-flex flex-row justify-content-center align-items-center text-center"
                                    @blur="fabInfoChanged(f.path, f.type)"
                                >
                                    <a-input
                                        class="col-8 inputs my-2 mr-2 p-3"
                                        v-model="f.path"
                                        v-if="f.path !== undefined"
                                        placeholder="https://twitter.com/..."
                                        autocomplete="off"
                                        trim
                                        type="text"
                                        @blur="fabInfoChanged(f.path, f.type)"
                                        style="margin-left: 1px"
                                    />
                                    <a-icon
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="$t('message.typeYourAccountLink', { accountLink: f.type })"
                                        class="col-1 mx-3"
                                        style="
                                            font-size: 20px;
                                            color: var(--color-bg-primary-default);
                                            background-color: #ffffff;
                                            border-radius: 50%;
                                        "
                                        theme="filled"
                                        type="info-circle"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-if="f.type === 'instagram'" class="mt-2 pt-2">
                            <div v-show="f.enable === true" class="text-center">
                                <div
                                    class="row d-flex flex-row justify-content-center align-items-center text-center"
                                    @blur="fabInfoChanged(f.path, f.type)"
                                >
                                    <a-input
                                        class="col-8 inputs my-2 mr-2 p-3"
                                        v-model="f.path"
                                        v-if="f.path !== undefined"
                                        placeholder="https://www.instagram.com/..."
                                        autocomplete="off"
                                        trim
                                        type="text"
                                        @blur="fabInfoChanged(f.path, f.type)"
                                        style="margin-left: 1px"
                                    />
                                    <a-icon
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="$t('message.typeYourAccountLink', { accountLink: f.type })"
                                        class="col-1 mx-3"
                                        style="
                                            font-size: 20px;
                                            color: var(--color-bg-primary-default);
                                            background-color: #ffffff;
                                            border-radius: 50%;
                                        "
                                        theme="filled"
                                        type="info-circle"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-if="f.type === 'youtube'" class="mt-2 pt-2">
                            <div v-show="f.enable === true" class="text-center">
                                <div
                                    class="row d-flex flex-row justify-content-center align-items-center text-center"
                                    @blur="fabInfoChanged(f.path, f.type)"
                                >
                                    <a-input
                                        class="col-8 inputs my-2 mr-2 p-3"
                                        v-model="f.path"
                                        v-if="f.path !== undefined"
                                        placeholder="https://www.youtube.com/..."
                                        autocomplete="off"
                                        trim
                                        type="text"
                                        @blur="fabInfoChanged(f.path, f.type)"
                                        style="margin-left: 1px"
                                    />
                                    <a-icon
                                        v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                                        :content="$t('message.typeYourChannelLink', { channelLink: f.type })"
                                        class="col-1 mx-3"
                                        style="
                                            font-size: 20px;
                                            color: var(--color-bg-primary-default);
                                            background-color: #ffffff;
                                            border-radius: 50%;
                                        "
                                        theme="filled"
                                        type="info-circle"
                                    />
                                </div>
                            </div>
                        </div>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import VueCountryCode from "vue-country-code";
import VueTheMask from "vue-the-mask";
import { log2 } from "../utils/log2";
import { mapActions, mapGetters, mapState } from "vuex";

Vue.use(VueTheMask);
Vue.use(VueCountryCode);
const log = log2("Settings");
const fabList = [
    {
        enable: true,
        type: "live",
        description: "FabListDescription",
    },
    {
        enable: true,
        type: "ticket",
        description: "FabListDescription",
    },
    {
        enable: true,
        type: "whatsapp",
        description: "FabListDescription",
        url: "https://wa.me/",
        path: "",
        country: "tr",
        callingCode: "90",
        text: "",
    },
    {
        enable: true,
        type: "phone",
        description: "FabListDescription",
        tel: "",
        country: "tr",
        callingCode: "90",
    },
    {
        enable: true,
        type: "email",
        description: "FabListDescription",
        mail: "",
        text: "",
    },
    {
        enable: true,
        type: "facebook",
        description: "FabListDescription",
        path: "",
    },
    {
        enable: true,
        type: "twitter",
        description: "FabListDescription",
        path: "",
    },
    {
        enable: true,
        type: "instagram",
        description: "FabListDescription",
        path: "",
    },
    {
        enable: true,
        type: "youtube",
        description: "FabListDescription",
        path: "",
    },
];

export default {
    name: "FAB",
    data() {
        return {
            fabList: _.cloneDeep(fabList),
            enablefabs: [],
            activeBorderWP: "1px solid #e5e5e5",
            activeBorderPhone: "1px solid #e5e5e5",
            handleSave: _.debounce((newSettings) => {
                this.updateSettings(newSettings);
            }, 1000).bind(this),
            validInput: "classs-success",
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            isDarkMode: (state) => state.darkMode,
        }),
        ...mapGetters({}),
        fabs: {
            get() {
                return _.get(this.settings.fab, "items");
            },
            set(value) {
                this.setValue("fab.items", value);
            },
        },
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        isMailValid(email) {
            const validationControl = email == "" ? "" : this.reg.test(email) ? "has-success" : "has-error";
            this.validInput = validationControl === "has-success" ? "classs-success" : "classs-error";
            return this.validInput;
        },
        onSelect(e, type = undefined) {
            if (type !== undefined) {
                if (type === "whatsapp") {
                    this.fabs.find((x) => x.type === "whatsapp").callingCode = !!e && !!e.dialCode ? e.dialCode : "90";
                    this.fabs.find((x) => x.type === "whatsapp").country =
                        !!e && !!e.iso2 ? e.iso2.toLowerCase() : "tr";
                } else if (type === "phone") {
                    this.fabs.find((x) => x.type === "phone").callingCode = !!e && !!e.dialCode ? e.dialCode : "90";
                    this.fabs.find((x) => x.type === "phone").country = !!e && !!e.iso2 ? e.iso2.toLowerCase() : "tr";
                }
                this.setValue("fab.items", this.fabs);
                this.enablefabs = this.fabs.filter((x) => x.enable === true);
                this.$emit("enable-fabs", this.enablefabs);
            }
        },
        setValue(key, value) {
            const newSettings = this.setSettingValue({
                setting: key,
                value,
            });

            if (newSettings.then) {
                newSettings.then((x) => this.handleSave(x));
            } else {
                this.handleSave(newSettings);
            }
        },
        fabInfoChanged(inputValue = undefined, typ = "") {
            if (!!typ && inputValue !== undefined) {
                if (typ === "email") {
                    if (this.isMailValid(inputValue) === "classs-error")
                        this.$message.error(this.$t("message.emailIsNotCorrect"), 4);
                }
                if ((typ === "whatsapp" || typ === "phone") && inputValue.length < 12) {
                    if (typ === "whatsapp") this.activeBorderWP = "1px solid red";
                    else if (typ === "phone") this.activeBorderPhone = "1px solid red";
                    this.$message.error(this.$t("message.numberIsNotCorrect"), 4);
                }
            } else {
                if (!!typ) {
                    if (typ === "whatsapp") this.activeBorderWP = "1px solid #e5e5e5";
                    else if (typ === "phone") this.activeBorderPhone = "1px solid #e5e5e5";
                }
            }
            this.setValue("fab.items", this.fabs);
            this.enablefabs = this.fabs.filter((x) => x.enable === true);
            this.$emit("enable-fabs", this.enablefabs);
        },
    },
};
</script>

<style lang="scss" scoped>
#fab {
    .options {
        border: 1px solid #e5e5e5;
        padding: 6px;
        position: relative;
        border-radius: 6px;
        -webkit-box-shadow: 0 0 2px #00000080;
        box-shadow: 0 0 2px #00000080;
    }

    .inputs {
        border: 1px solid #e5e5e5;
        position: relative;
        border-radius: 6px;
        -webkit-box-shadow: 0 0 1px #00000080;
        box-shadow: 0 0 1px #00000080;
    }

    .country-code {
        border: 1px solid #e5e5e5;
        position: relative;
        height: 50px;
        border-radius: 6px;
        -webkit-box-shadow: 0 0 1px rgb(0 0 0 / 50%);
        box-shadow: 0 0 1px rgb(0 0 0 / 50%);
    }

    select {
        font-size: 14px;
        border: none;
        width: 100%;
        background: white;
        font-weight: 400;
    }

    .parent {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .child {
        margin: 10px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        width: 100%;
        border: 1px solid #c7c8d0;
        padding: 20px;
        font-size: 16px;
        cursor: pointer;
        min-width: 500px;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: start;
    }

    .classs-error {
        border: 1px solid red;
    }

    .classs-success {
        border: 1px solid #e5e5e5;
    }
}

.mx-2.p-1:checked {
    background-color: red;
}
</style>
